/* Help Alert landing pages — behaviour (vanilla JS, no dependencies).
   Loaded with "defer" by layout/ha-landing.liquid only.

   Tracking brief covered here:
   - Click id, first landing page and Stripe links are handled by ha-attr.js.
   - This file only adds prefilled_email, and copies attribution onto the cart
     after marketing consent.
   - Phone numbers use .ha-phone so Google's forwarding number can swap them;
     tap-to-call links follow the swapped number.
   - dataLayer events: cta_order_click, cta_call_click, callback_form_submit,
     quiz_complete (via window.haQuizComplete). Every event carries page_cluster.
   - Respects Google Consent Mode: the cookie is only written once marketing
     consent is granted. No Google Ads tags here: everything goes through GTM.

   Debug: add ?ha_debug=1 to the page URL to log every event to the console. */
(function () {
  'use strict';
  if (window.__haLp) return;
  window.__haLp = true;

  var body = document.body;
  var DEBUG = /[?&]ha_debug=1\b/.test(window.location.search);
  var CART_KEYS = ['gclid', 'gbraid', 'wbraid', 'utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content', 'landing_page'];

  var page = {
    page_type: 'ha_landing',
    page_cluster: body.getAttribute('data-ha-cluster') || 'generic',
    page_handle: body.getAttribute('data-ha-page') || '',
    campaign: body.getAttribute('data-ha-campaign') || '',
    variant: body.getAttribute('data-ha-variant') || ''
  };

  /* ---------- dataLayer ---------- */
  window.dataLayer = window.dataLayer || [];
  function track(event, extra) {
    var payload = { event: event };
    var k;
    for (k in page) payload[k] = page[k];
    if (extra) for (k in extra) payload[k] = extra[k];
    window.dataLayer.push(payload);
    if (DEBUG && window.console) console.log('[HA dataLayer]', payload);
  }

  /* ---------- Consent (Shopify Customer Privacy API) ---------- */
  function marketingAllowed() {
    try {
      var cp = window.Shopify && window.Shopify.customerPrivacy;
      if (cp && typeof cp.marketingAllowed === 'function') return cp.marketingAllowed();
    } catch (err) {}
    return false;
  }

  /* Click id and the first page live in ha-attr.js. */
  var params = new URLSearchParams(window.location.search);
  function storedAttr() {
    return (typeof window.haAttribution === 'function') ? window.haAttribution() : {};
  }

  var prefilledEmail = params.get('prefilled_email') || params.get('email') || '';
  try { if (!prefilledEmail) prefilledEmail = sessionStorage.getItem('ha_email') || ''; } catch (err) {}

  var cartCopied = false;
  function copyToCart() {
    if (cartCopied || !marketingAllowed()) return;
    cartCopied = true;
    var attr = storedAttr();
    var cartAttrs = {};
    CART_KEYS.forEach(function (key) { if (attr[key]) cartAttrs['ha_' + key] = attr[key]; });
    cartAttrs.ha_page_cluster = page.page_cluster;
    if (page.variant) cartAttrs.ha_variant = page.variant;
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    if (window.fetch && window.location.protocol.indexOf('http') === 0) {
      fetch(root + 'cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ attributes: cartAttrs })
      }).catch(function () {});
    }
  }
  copyToCart();
  track('ha_attribution', storedAttr());
  document.addEventListener('visitorConsentCollected', function () { copyToCart(); });
  setTimeout(copyToCart, 1500);

  document.querySelectorAll('[data-ha-utm]').forEach(function (input) {
    var attr = storedAttr();
    input.value = attr[input.getAttribute('data-ha-utm')] || '';
  });

  /* Stripe click id and page are added by ha-attr.js. */
  function isStripe(href) {
    return /^https:\/\/(buy|checkout)\.stripe\.com\//i.test(href || '');
  }
  function decorate(a) {
    if (!a || !isStripe(a.href) || !prefilledEmail) return;
    try {
      var u = new URL(a.href);
      u.searchParams.set('prefilled_email', prefilledEmail);
      a.href = u.toString();
    } catch (err) {}
  }

  /* ---------- Phone number swap support ---------- */
  // Google's forwarding-number script replaces the text inside .ha-phone.
  // When that happens, point every tap-to-call link at the new number.
  var phoneEls = document.querySelectorAll('.ha-phone');
  var original = phoneEls[0] ? phoneEls[0].textContent.replace(/\D/g, '') : '';
  function syncTel() {
    var swapped = '';
    phoneEls.forEach(function (el) {
      var d = el.textContent.replace(/\D/g, '');
      if (d && d !== original) swapped = el.textContent.trim();
    });
    if (!swapped) return;
    var dial = swapped.replace(/[^\d+]/g, '');
    if (dial.charAt(0) === '0') dial = '+44' + dial.slice(1);
    document.querySelectorAll('a[data-ha-phone]').forEach(function (a) { a.href = 'tel:' + dial; });
    phoneEls.forEach(function (el) { if (el.textContent.trim() !== swapped) el.textContent = swapped; });
  }
  if (phoneEls.length && 'MutationObserver' in window) {
    var mo = new MutationObserver(syncTel);
    phoneEls.forEach(function (el) { mo.observe(el, { childList: true, characterData: true, subtree: true }); });
    var checks = 0;
    var phoneWatch = setInterval(function () { syncTel(); if (++checks > 20) clearInterval(phoneWatch); }, 500);
  }

  /* ---------- Click tracking ---------- */
  document.addEventListener('click', function (e) {
    var el = e.target.closest ? e.target.closest('[data-ha-track]') : null;
    if (!el) return;
    var kind = el.getAttribute('data-ha-track');
    var where = el.getAttribute('data-ha-location') || '';
    if (kind === 'order') {
      decorate(el);
      var href = el.getAttribute('href') || '';
      track('cta_order_click', {
        plan: el.getAttribute('data-ha-plan') || 'not_selected',
        product: el.getAttribute('data-ha-product') || (/pendant/i.test(href) ? 'pendant' : 'watch'),
        cta_location: where,
        link_url: el.href,
        checkout_type: isStripe(el.href) ? 'stripe' : 'shopify'
      });
    } else if (kind === 'call') {
      track('cta_call_click', { cta_location: where, phone_number: (el.querySelector('.ha-phone') || phoneEls[0] || {}).textContent || '' });
    }
  });

  document.querySelectorAll('.ha-lp-faq details').forEach(function (d) {
    d.addEventListener('toggle', function () {
      if (d.open) track('faq_open', { faq: d.querySelector('summary').textContent.trim() });
    });
  });

  // For a quiz embedded on a landing page: call window.haQuizComplete({ result: 'watch' }).
  window.haQuizComplete = function (detail) {
    var extra = { quiz_result: (detail && detail.result) || '' };
    track('quiz_complete', extra);
  };

  /* ---------- Opening-hours status (UK time) ---------- */
  var status = document.querySelector('[data-ha-hours]');
  if (status) {
    try {
      var hours = JSON.parse(status.getAttribute('data-ha-hours'));
      var dt = new Intl.DateTimeFormat('en-GB', {
        timeZone: 'Europe/London', weekday: 'short', hour: '2-digit', minute: '2-digit', hour12: false
      }).formatToParts(new Date());
      var get = function (t) { return (dt.filter(function (p) { return p.type === t; })[0] || {}).value; };
      var day = get('weekday');
      var now = parseInt(get('hour'), 10) % 24 * 60 + parseInt(get('minute'), 10);
      var span = hours[day === 'Sat' ? 'sat' : day === 'Sun' ? 'sun' : 'week'];
      var toMin = function (t) { var m = /^(\d{1,2}):(\d{2})$/.exec((t || '').trim()); return m ? (+m[1]) * 60 + (+m[2]) : null; };
      var open = span && toMin(span[0]) !== null && toMin(span[1]) !== null && now >= toMin(span[0]) && now < toMin(span[1]);
      status.querySelector('[data-ha-status]').innerHTML = open ? status.getAttribute('data-open-text') : status.getAttribute('data-closed-text');
      if (!open) status.querySelector('.ha-lp-dot').setAttribute('data-closed', '');
    } catch (err) {}
  }

  /* ---------- Watch faces show the visitor's current time and date ---------- */
  function tickWatch() {
    var d = new Date();
    var set = function (sel, val) { document.querySelectorAll(sel).forEach(function (n) { n.textContent = val; }); };
    set('[data-ha-w="h"]', String(d.getHours()).padStart(2, '0'));
    set('[data-ha-w="m"]', String(d.getMinutes()).padStart(2, '0'));
    set('[data-ha-w="date"]', d.getDate() + '/' + (d.getMonth() + 1));
    set('[data-ha-w="day"]', d.toLocaleDateString('en-GB', { weekday: 'short' }));
  }
  if (document.querySelector('[data-ha-w]')) { tickWatch(); setInterval(tickWatch, 15000); }

  /* ---------- Mobile sticky bar ---------- */
  var bar = document.querySelector('.ha-lp-sticky');
  if (bar) {
    var heroCtas = document.querySelector('[data-ha-hero-ctas]');
    var heroVisible = !!heroCtas;
    var typing = false;
    var setBar = function () {
      var show = !heroVisible && !typing;
      if (show) bar.setAttribute('data-show', ''); else bar.removeAttribute('data-show');
      bar.setAttribute('aria-hidden', show ? 'false' : 'true');
      bar.querySelectorAll('.ha-lp-sticky__bar a, .ha-lp-sticky__bar button').forEach(function (a) { a.tabIndex = show ? 0 : -1; });
    };
    if (heroCtas && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        var en = entries[0];
        heroVisible = en.isIntersecting || en.boundingClientRect.top > 0;
        setBar();
      }).observe(heroCtas);
    } else {
      heroVisible = false;
    }
    document.addEventListener('focusin', function (e) {
      if (e.target.closest && e.target.closest('.ha-lp-form')) { typing = true; setBar(); }
    });
    document.addEventListener('focusout', function () {
      setTimeout(function () {
        var el = document.activeElement;
        typing = !!(el && el.closest && el.closest('.ha-lp-form'));
        setBar();
      }, 60);
    });
    setBar();
  }

  /* ---------- Customer story video (loads only when played) ---------- */
  document.querySelectorAll('[data-ha-video]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var frame = document.createElement('iframe');
      frame.src = btn.getAttribute('data-ha-video');
      frame.title = btn.getAttribute('aria-label') || 'Customer story video';
      frame.allow = 'autoplay; encrypted-media; picture-in-picture; fullscreen';
      frame.setAttribute('allowfullscreen', '');
      btn.parentNode.replaceChild(frame, btn);
      track('video_play');
    });
  });

  /* ---------- Callback form ---------- */
  function callbackIsWeekend() {
    var day = new Intl.DateTimeFormat('en-GB', { timeZone: 'Europe/London', weekday: 'short' }).format(new Date());
    return day === 'Sat' || day === 'Sun';
  }
  function callbackWhenMessage(choice) {
    var c = String(choice || '').trim().toLowerCase();
    var weekend = callbackIsWeekend();
    var when = '';
    if (weekend && c.indexOf('soon') !== -1) when = 'on Monday. We are closed over the weekend';
    else if (weekend && c === 'morning') when = 'on Monday morning. We are closed over the weekend';
    else if (weekend && c === 'afternoon') when = 'on Monday afternoon. We are closed over the weekend';
    else if (weekend && c.indexOf('evening') !== -1) when = 'on Monday early evening. We are closed over the weekend';
    else if (weekend) when = 'on Monday. We are closed over the weekend';
    else if (c.indexOf('soon') !== -1) when = 'as soon as possible';
    else if (c === 'morning') when = 'in the morning';
    else if (c === 'afternoon') when = 'in the afternoon';
    else if (c.indexOf('evening') !== -1) when = 'in the early evening';
    else if (c) when = 'at the time you asked for';
    if (!when) return 'One of our team will call you back. There is nothing more you need to do.';
    return 'One of our team will call you back ' + when + '. There is nothing more you need to do.';
  }

  document.querySelectorAll('[data-ha-callback]').forEach(function (form) {
    var more = form.querySelector('[data-ha-more]');
    var extra = form.querySelector('[data-ha-extra]');
    if (more && extra) {
      more.addEventListener('click', function () {
        var opening = extra.hidden;
        extra.hidden = !opening;
        more.setAttribute('aria-expanded', String(opening));
        more.textContent = opening ? more.getAttribute('data-close-text') : more.getAttribute('data-open-text');
        if (opening) { var first = extra.querySelector('input, textarea'); if (first) first.focus(); }
      });
    }

    var setErr = function (input, msg) {
      var err = document.getElementById(input.id + '-err');
      input.setAttribute('aria-invalid', msg ? 'true' : 'false');
      if (err) { err.hidden = !msg; err.textContent = msg || ''; }
    };
    form.querySelectorAll('input, textarea').forEach(function (i) {
      i.addEventListener('input', function () { if (i.getAttribute('aria-invalid') === 'true') setErr(i, ''); });
    });

    var submitted = false;
    var popup = form.closest('.ha-lp-section') ? form.closest('.ha-lp-section').querySelector('[data-ha-popup]') : null;
    if (popup) {
      var closeBtn = popup.querySelector('[data-ha-popup-close]');
      if (closeBtn) closeBtn.addEventListener('click', function () { popup.close(); });
    }
    var frame = document.createElement('iframe');
    frame.name = 'ha-callback-frame-' + Math.random().toString(36).slice(2);
    frame.hidden = true;
    frame.setAttribute('aria-hidden', 'true');
    frame.tabIndex = -1;
    document.body.appendChild(frame);
    form.setAttribute('target', frame.name);
    var awaiting = false;
    frame.addEventListener('load', function () {
      if (!awaiting) return;
      awaiting = false;
      if (popup && typeof popup.showModal === 'function' && !popup.open) {
        try { popup.showModal(); } catch (err) { popup.setAttribute('open', ''); }
      }
    });
    form.addEventListener('submit', function (e) {
      if (submitted) { e.preventDefault(); return; }
      var name = form.querySelector('[data-ha-field="name"]');
      var phone = form.querySelector('[data-ha-field="phone"]');
      var email = form.querySelector('[data-ha-field="email"]');
      var realEmail = form.querySelector('[data-ha-field="email-out"]');
      var errors = [];

      if (!name.value.trim()) { setErr(name, 'Enter your name so we know who to ask for.'); errors.push([name, 'Enter your name']); }
      else setErr(name, '');

      var digits = phone.value.replace(/\D/g, '');
      if (digits.length < 10 || digits.length > 13) { setErr(phone, 'Enter a UK phone number, like 07700 900123.'); errors.push([phone, 'Enter a phone number we can call']); }
      else setErr(phone, '');

      if (email && email.value.trim() && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email.value.trim())) {
        setErr(email, 'Enter an email address like name@example.com, or leave it blank.');
        errors.push([email, 'Check the email address']);
      } else if (email) setErr(email, '');

      var summary = form.querySelector('[data-ha-summary]');
      var list = summary.querySelector('ul');
      list.innerHTML = '';
      if (errors.length) {
        e.preventDefault();
        errors.forEach(function (x) {
          var li = document.createElement('li');
          var a = document.createElement('a');
          a.href = '#' + x[0].id;
          a.textContent = x[1];
          a.addEventListener('click', function (ev) { ev.preventDefault(); x[0].focus(); });
          li.appendChild(a);
          list.appendChild(li);
        });
        summary.hidden = false;
        summary.focus();
        return;
      }
      summary.hidden = true;

      var note = form.querySelector('[data-ha-field="message"]');
      var bodyOut = form.querySelector('[data-ha-field="body-out"]');
      if (note && bodyOut) {
        var written = note.value.trim();
        bodyOut.value = written ? ('Callback form submission\n\n' + written) : 'Callback form submission';
        if (!written) note.removeAttribute('name');
      }

      var typedEmail = email && email.value.trim();
      if (typedEmail) {
        prefilledEmail = typedEmail;
        try { sessionStorage.setItem('ha_email', typedEmail); } catch (err) {}
      }
      // Shopify's contact form needs an email; use the "no email given" address if blank.
      realEmail.value = typedEmail || form.getAttribute('data-ha-fallback-email') || '';

      var forWho = form.querySelector('input[name="contact[Alarm is for]"]:checked');
      var timeField = form.querySelector('[name="contact[Best time to call]"]');
      var timeChoice = timeField ? timeField.value : '';
      try { sessionStorage.setItem('ha_callback_when', timeChoice); } catch (err) {}
      if (popup) {
        var whenLine = popup.querySelector('[data-ha-when]');
        if (whenLine) whenLine.textContent = callbackWhenMessage(timeChoice);
      }
      track('callback_form_submit', { callback_for: forWho ? forWho.value : '', callback_when: timeChoice, has_click_id: !!clientRef() });

      // Optional CRM webhook: the Shopify email still goes out if this fails.
      var hook = form.getAttribute('data-ha-webhook');
      if (hook && window.fetch) {
        var data = {};
        new FormData(form).forEach(function (v, k) {
          var m = /^contact\[(.+)\]$/.exec(k);
          if (m) data[m[1]] = v;
        });
        data.page_cluster = page.page_cluster;
        data.submitted_at = new Date().toISOString();
        data.page_url = window.location.href;
        try {
          fetch(hook, { method: 'POST', mode: 'no-cors', keepalive: true, headers: { 'Content-Type': 'text/plain' }, body: JSON.stringify(data) });
        } catch (err) {}
      }
      submitted = true;
      awaiting = true;
      var btn = form.querySelector('[type="submit"]');
      if (btn) { btn.setAttribute('aria-disabled', 'true'); btn.textContent = btn.getAttribute('data-sending-text') || 'Sending…'; }
    });
  });

  /* Order buttons open plan costs. The mobile bar grows upward; other buttons expand in place. */
  var planData = null;
  var planNode = document.getElementById('ha-lp-plan-data');
  if (planNode) { try { planData = JSON.parse(planNode.textContent); } catch (err) { planData = null; } }
  if (!planData) {
    planData = {
      monthly: { title: 'Monthly', price: '£30', period: 'a month', rows: 'Watch (one-off) | £49.99\nPay today | £79.99', button: 'Order monthly', url: 'https://buy.stripe.com/eVqfZhccpe8IdF46fp57W1J' },
      annual: { title: 'Annual', price: '£300', period: 'a year', save: 'Save £60', rows: 'Works out at | £25 a month\nWatch (one-off) | £49.99\nPay today | £349.99', button: 'Order annually', url: 'https://buy.stripe.com/cNidR9ekx1lW6cCgU357W1K' }
    };
  }
  function planRows(plan) {
    return String(plan.rows || '').split(/\n/).map(function (line) {
      var bits = line.split('|');
      if (bits.length < 2) return null;
      return { label: bits[0].trim(), amount: bits.slice(1).join('|').trim() };
    }).filter(Boolean);
  }
  function planBits(plan) {
    var rows = planRows(plan);
    var watch = null;
    var total = null;
    var note = null;
    rows.forEach(function (row) {
      var name = row.label.toLowerCase();
      if (name.indexOf('watch') !== -1) watch = row;
      else if (name.indexOf('pay today') !== -1 || name.indexOf('total') !== -1) total = row;
      else note = row;
    });
    return { watch: watch, total: total, note: note };
  }
  function esc(value) {
    return String(value || '').replace(/[&<>"']/g, function (ch) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[ch];
    });
  }
  function planCard(plan, key, featured) {
    var bits = planBits(plan);
    var art = document.createElement('article');
    art.className = 'ha-lp-choose__opt' + (featured ? ' is-best' : '');
    var save = plan.save ? '<small>' + esc(plan.save) + '</small>' : '';
    var lines = '<div><dt>Subscription</dt><dd>' + esc(plan.price) + '</dd></div>';
    if (bits.note) lines += '<div><dt>' + esc(bits.note.label) + '</dt><dd>' + esc(bits.note.amount) + '</dd></div>';
    if (bits.watch) lines += '<div><dt>Watch</dt><dd>' + esc(bits.watch.amount) + '</dd></div>';
    if (bits.total) lines += '<div class="is-total"><dt>Total today</dt><dd>' + esc(bits.total.amount) + '</dd></div>';
    art.innerHTML = '<span>' + esc(plan.title) + '</span><b>' + esc(plan.price) + '</b><small>' + esc(plan.period) + '</small>' + save + '<dl class="ha-lp-choose__lines">' + lines + '</dl>';
    var link = document.createElement('a');
    link.className = 'ha-lp-btn ' + (featured ? 'ha-lp-btn--order' : 'ha-lp-btn--ghost');
    link.href = plan.url || '#';
    link.setAttribute('data-ha-track', 'order');
    link.setAttribute('data-ha-plan', key);
    link.setAttribute('data-ha-product', 'watch');
    link.setAttribute('data-ha-location', 'choose_' + key);
    link.textContent = plan.button || ('Order ' + String(plan.title || key).toLowerCase());
    decorate(link);
    art.appendChild(link);
    return art;
  }
  function stickyPlan(plan, key, featured) {
    var bits = planBits(plan);
    var art = document.createElement('article');
    art.className = 'ha-lp-sticky__plan' + (featured ? ' is-best' : '');
    var save = plan.save ? '<span>' + esc(plan.save) + '</span>' : '';
    var lines = '<div><dt>Subscription</dt><dd>' + esc(plan.price) + '<small>' + esc(plan.period) + '</small></dd></div>';
    if (bits.note) lines += '<div><dt>' + esc(bits.note.label) + '</dt><dd>' + esc(bits.note.amount) + '</dd></div>';
    if (bits.watch) lines += '<div><dt>Watch</dt><dd>' + esc(bits.watch.amount) + '<small>one-off</small></dd></div>';
    if (bits.total) lines += '<div class="is-total"><dt>Total today</dt><dd>' + esc(bits.total.amount) + '</dd></div>';
    art.innerHTML = '<h3>' + esc(plan.title) + save + '</h3><dl>' + lines + '</dl>';
    var link = document.createElement('a');
    link.className = 'ha-lp-btn ' + (featured ? 'ha-lp-btn--order' : 'ha-lp-btn--ghost');
    link.href = plan.url || '#';
    link.setAttribute('data-ha-track', 'order');
    link.setAttribute('data-ha-plan', key);
    link.setAttribute('data-ha-product', 'watch');
    link.setAttribute('data-ha-location', 'sticky_' + key);
    link.textContent = plan.button || ('Order ' + plan.title.toLowerCase());
    decorate(link);
    art.appendChild(link);
    return art;
  }
  document.addEventListener('click', function (e) {
    var link = e.target.closest ? e.target.closest('a[data-ha-track="order"]') : null;
    if (!link || link.classList.contains('ha-lp-choose__opt') || link.closest('.ha-lp-sticky')) return;
    var plan = link.getAttribute('data-ha-plan') || '';
    var label = (link.textContent || '').toLowerCase();
    if (plan === 'trial' || plan === 'monthly' || plan === 'annual') return;
    if (label.indexOf('order') === -1) return;
    e.preventDefault();
    e.stopPropagation();
    var existing = link.parentNode.querySelector('[data-ha-choose-open]');
    if (!existing) {
      var button = document.createElement('button');
      button.type = 'button';
      button.className = link.className;
      button.setAttribute('data-ha-choose-open', '');
      button.setAttribute('aria-expanded', 'false');
      button.innerHTML = link.innerHTML;
      var wrap = document.createElement('div');
      wrap.className = 'ha-lp-choose';
      var panel = document.createElement('div');
      panel.className = 'ha-lp-choose__panel';
      panel.setAttribute('data-ha-choose-panel', '');
      panel.hidden = true;
      link.parentNode.insertBefore(wrap, link);
      wrap.appendChild(button);
      wrap.appendChild(panel);
      link.remove();
      button.click();
    }
  }, true);

  document.addEventListener('click', function (e) {
    var btn = e.target.closest ? e.target.closest('[data-ha-choose-open]') : null;
    if (!btn) return;
    var wrap = btn.parentNode;
    var panel = wrap.querySelector('[data-ha-choose-panel]');
      document.querySelectorAll('[data-ha-choose-panel]').forEach(function (other) {
        if (other !== panel) {
          other.hidden = true;
          var opener = other.parentNode.querySelector('[data-ha-choose-open]');
          if (opener) { opener.hidden = false; opener.setAttribute('aria-expanded', 'false'); }
        }
      });
      if (!panel.childElementCount && planData) {
        var head = document.createElement('p');
        head.className = 'ha-lp-choose__head';
        head.innerHTML = 'Choose monthly or annual';
        var back = document.createElement('button');
        back.type = 'button';
        back.className = 'ha-lp-choose__back';
        back.textContent = 'Back';
        back.addEventListener('click', function () {
          panel.hidden = true;
          btn.hidden = false;
          btn.setAttribute('aria-expanded', 'false');
          btn.focus();
        });
        head.appendChild(back);
        var opts = document.createElement('div');
        opts.className = 'ha-lp-choose__opts';
        opts.appendChild(planCard(planData.monthly, 'monthly', false));
        opts.appendChild(planCard(planData.annual, 'annual', true));
        panel.appendChild(head);
        panel.appendChild(opts);
      }
      btn.hidden = true;
      btn.setAttribute('aria-expanded', 'true');
      panel.hidden = false;
      var first = panel.querySelector('a');
      if (first) first.focus();
    });

  var sticky = document.querySelector('.ha-lp-sticky');
  if (sticky && planData) {
    var sheet = sticky.querySelector('[data-ha-sticky-sheet]');
    var opener = sticky.querySelector('[data-ha-sticky-open]');
    var scrim = sticky.querySelector('[data-ha-sticky-scrim], [data-ha-sticky-close]');
    function fillSticky() {
      if (sheet.childElementCount) return;
      var head = document.createElement('div');
      head.className = 'ha-lp-sticky__head';
      head.innerHTML = '<h2>What you pay</h2>';
      var close = document.createElement('button');
      close.type = 'button';
      close.className = 'ha-lp-sticky__close';
      close.textContent = 'Close';
      close.addEventListener('click', closeSticky);
      head.appendChild(close);
      var plans = document.createElement('div');
      plans.className = 'ha-lp-sticky__plans';
      plans.appendChild(stickyPlan(planData.monthly, 'monthly', false));
      plans.appendChild(stickyPlan(planData.annual, 'annual', true));
      sheet.appendChild(head);
      sheet.appendChild(plans);
    }
    function openSticky() {
      fillSticky();
      scrim.hidden = false;
      sheet.hidden = false;
      void sheet.offsetHeight;
      sticky.classList.add('is-open');
      opener.setAttribute('aria-expanded', 'true');
      var close = sheet.querySelector('.ha-lp-sticky__close');
      if (close) close.focus();
    }
    function closeSticky() {
      sticky.classList.remove('is-open');
      opener.setAttribute('aria-expanded', 'false');
      scrim.hidden = true;
      window.setTimeout(function () {
        if (!sticky.classList.contains('is-open')) sheet.hidden = true;
      }, 400);
      opener.focus();
    }
    opener.addEventListener('click', function () {
      if (sticky.classList.contains('is-open')) closeSticky();
      else openSticky();
    });
    scrim.addEventListener('click', closeSticky);
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && sticky.classList.contains('is-open')) closeSticky();
    });
  }

  var ok = document.querySelector('[data-ha-success]');
  if (ok) {
    var savedWhen = '';
    try { savedWhen = sessionStorage.getItem('ha_callback_when') || ''; } catch (err) {}
    if (savedWhen) {
      ok.querySelectorAll('[data-ha-when]').forEach(function (line) {
        line.textContent = callbackWhenMessage(savedWhen);
      });
    }
    ok.focus();
  }
})();
